const fi = {
    translation: {
      ui: {
        viewMode: {
          floorPlan: {
            label: "Pohjakuva",
            description: "Asunnon pohjakuva."
          },
          threeD: {
            label: "3D",
            description: "Asunnon 3D-malli."
          },
          dollhouse: {
            label: "Nukkekoti",
            description: "Asunnon nukkekoti-malli."
          }
        },
        loadingState: {
          loading: "Ladataan...",
          error: "Virhe ladattaessa sisältöä",
          initial: "Valmistellaan..."
        },
        commandButton: {
          disabledDueToActiveCommand: "Komentoa ei voi käynnistää toisen komennon ollessa aktiivinen",
          disableDueToRights: "Sinulla ei ole tarvittavia oikeuksia tämän komennon suorittamiseen",
          clickToCancelCommand: "Klikkaa peruuttaaksesi komennon"
        },
        storeySelector: {
          title: "Klikkaa siirtyäksesi seuraavaan kerrokseen",
          nameFormat: "{{ordinal}} Kerros"
        },
        roomNote: {
          dialog: {
            noteSection: "Muistiinpano",
            notePlaceholder: "Kirjoita muistiinpano tälle huoneelle",
            saving: "Tallennetaan…",
            error: {
              validation: "Muistiinpanoa ei voitu tallentaa. Tarkista, että se on enintään 2000 merkkiä.",
              unauthorized: "Istuntosi on vanhentunut. Lataa sivu uudelleen kirjautuaksesi.",
              forbidden: "Sinulla ei ole oikeutta muokata muistiinpanoja.",
              notFound: "Huonetta ei löytynyt huoneistosta. Lataa sivu uudelleen päivittääksesi mallin.",
              failed: "Tallennus epäonnistui, yritä uudelleen."
            }
          }
        },
        selectionToolbar: {
          info: "Ominaisuudet",
          move: "Siirrä",
          clone: "Monista",
          delete: "Poista",
          type: {
            lengthDimension: "Mitta",
            textAnnotation: "Teksti",
            areaAnnotation: "Alue",
            rectangleAnnotation: "Suorakulmio",
            circleAnnotation: "Ympyrä",
            checklistItem: "Tarkastuslistakohde",
            object: "Objekti"
          }
        },
        editHandle: {
          tooltip: {
            startPoint: "Siirrä alkupistettä",
            endPoint: "Siirrä loppupistettä",
            dimensionOffset: "Säädä etäisyyttä",
            polygonVertex: "Siirrä kärkeä",
            rectangleCorner: "Siirrä kulmapistettä",
            circleRadius: "Aseta ympyrän säde",
            extrusionDepth: "Aseta paksuus"
          }
        },
        propertiesPanel: {
          title: "Ominaisuudet",
          readOnly: "Vain luku",
          multipleValues: "Useita arvoja",
          varies: "Vaihtelee",
          variesDescription: "Arvo vaihtelee valinnan sisällä. Muutos kohdistuu kaikkiin {{count}} valittuun kohteeseen.",
          mixedNote_one: "Katkoviivalliset kentät eroavat {{count}} valitun kohteen välillä. Yhden asettaminen kohdistuu kaikkiin {{count}}.",
          mixedNote_other: "Katkoviivalliset kentät eroavat {{count}} valitun kohteen välillä. Yhden asettaminen kohdistuu kaikkiin {{count}}.",
          selectionCount_one: "{{count}} {{type}}-elementti",
          selectionCount_other: "{{count}} {{type}}-elementtiä",
          elementsCount_one: "{{count}} elementti",
          elementsCount_other: "{{count}} elementtiä"
        }
      },
      properties: {
        category: {
          common: {
            name: "Yleiset"
          },
          dimensions: {
            name: "Mitat"
          }
        },
        field: {
          textContent: {
            name: "Teksti"
          },
          fontSize: {
            name: "Fontin koko"
          },
          rectWidth: {
            name: "Leveys"
          },
          rectHeight: {
            name: "Korkeus"
          },
          circleRadius: {
            name: "Säde"
          },
          showAreaText: {
            name: "Näytä pinta-ala"
          },
          extrusionDepth: {
            name: "Paksuus"
          },
          showVolume: {
            name: "Näytä tilavuus"
          },
          color: {
            name: "Väri"
          }
        }
      },
      command: {
        addLengthDimension: {
          title: "Lisää pituusmitta",
          selectFirstPoint: "Osoita pituusmitan alkupiste", 
          selectSecondPoint: "Osoita pituusmitan päätepiste",
          setOffset: "Aseta mittaluvun etäisyys mitattavasta kohteesta",
        },
        addTextAnnotation: {
          title: "Lisää teksti",
          setReferencePoint: "Osoita piste johon tekstillä viitataan",
          setTextPosition: "Osoita kohta johon teksti sijoitetaan",
          enterText: "Syötä lisättävä teksti ja valitse fonttikoko",
          dialog: {
            enterText: "Teksti",
            noteTextSection: "Teksti",
            notePlaceholder: "Kirjoita teksti…",
            addNote: "Lisää teksti",
            fontSize: "Fonttikoko",
            fontSizeSmallest: "Pienin",
            fontSizeSmall: "Pienempi",
            fontSizeMedium: "Oletus",
            fontSizeLarge: "Suurempi"
          }
        },
        addChecklistItem: {
          title: "Lisää tarkastuslistakohde",          
          setPosition: "Osoita tarkistuslistakohteen sijainti",
          confirmPosition: {
            title: "Vahvista sijainti",
            text: "Onko tarkistuslistakohde oikeassa paikassa?",
          },
        },
        addAreaAnnotation: {
          title: "Lisää alue",
          selectFirstPoint: "Osoita pinta aloittaaksesi ääriviivan piirtämisen",
          selectNextPoint: "Lisää pisteitä klikkaamalla, ja paina Valmis kun olet valmis",
          finish: "Valmis"
        },
        addRectangleAnnotation: {
          title: "Lisää suorakulmio",
          selectFirstPoint: "Osoita pinta asettaaksesi ensimmäisen kulman",
          selectSecondPoint: "Klikkaa asettaaksesi vastakkaisen kulman",
          finish: "Valmis"
        },
        addCircleAnnotation: {
          title: "Lisää ympyrä",
          selectFirstPoint: "Osoita pinta asettaaksesi keskipisteen",
          selectSecondPoint: "Klikkaa asettaaksesi säteen",
          finish: "Valmis"
        },
        removeFromDocument: {
          title: "Poista merkintöjä",
          selectObjectToRemove: "Valitse poistettava kohde.",
          clickToRemove: "Klikkaa poistaaksesi.",
          noPermission: "Sinulla ei ole oikeutta poistaa tätä objektia.",
          objectRemoved: "Objekti poistettu."
        },
        focusOnSceneObject: {
          title: "Kohdista objektiin"
        },
        select: {
          title: "Valitse",
          hover: "Valitse objekti klikkaamalla sitä"
        },
        geometryMoveEdit: {
          title: "Siirrä",
          prompt: "Osoita uusi sijainti ja klikkaa siirtääksesi"
        },
        moveSceneObjects: {
          title: "Siirrä",
          prompt: "Aloita siirto klikkaamalla nuolta tai tasoa, tai lopeta klikkaamalla muualle",
          promptDragging: "Osoita uusi sijainti ja klikkaa siirtääksesi"
        },
        cloneSceneObjects: {
          title: "Monista",
          prompt: "Aseta kopion sijainti"
        },
        bundleInspector: {
          title: "Elementtien tarkastelu",
          loading: "Ladataan elementtejä…",
          prompt: "Vie osoitin huone-elementin päälle nähdäksesi sen elementin, napsauta nähdäksesi tiedot",
          loadFailed: "Elementtejä ei voitu ladata. Peruuta ja yritä uudelleen.",
          noBundle: "Ei elementtiä",
          multipleBundles: "Huone-elementti kuuluu {{count}} elementtiin",
          units: {
            pcs: "kpl"
          },
          panel: {
            overview: "Yleiskatsaus",
            elements: "Huone-elementit",
            tabs: "Elementin tiedot",
            material: "Materiaali",
            noMaterial: "Materiaalia ei ole valittu",
            noElements: "Ei huone-elementtejä.",
            disabled: "Pois päältä",
            statePrefix: "Tila:",
            states: {
              open: "Avoin",
              locked: "Lukittu",
              confirmed: "Vahvistettu"
            },
            moreActions: "Lisää toimintoja",
            detachElements: "Irrota huone-elementtejä",
            detachHints: {
              locked: "Avaa elementin lukitus ensin.",
              confirmed: "Vahvistettuja elementtejä ei voi muuttaa.",
              noElements: "Ei irrotettavia huone-elementtejä.",
              singleElement: "Elementtiin on jäätävä vähintään yksi huone-elementti."
            }
          }
        },
        detachBundleElements: {
          title: "Irrota huone-elementtejä",
          prompt_one: "Valitse irrotettavat huone-elementit · {{count}} valittu",
          prompt_other: "Valitse irrotettavat huone-elementit · {{count}} valittu",
          detach: "Irrota",
          dialog: {
            title: "Irrota huone-elementtejä",
            from: "elementistä {{name}}",
            elements: "Huone-elementit ({{count}})",
            newBundle: "Uusi elementti",
            name: "Nimi",
            namePlaceholder: "{{name}} (Uusi)",
            level: "Taso",
            levels: {
              apartment: "Asunto",
              room: "Huone"
            },
            apartmentHelp: "Uusi elementti koskee koko asuntoa, ei yhtä huonetta.",
            room: "Huone",
            roomPlaceholder: "Valitse huone…",
            roomHelp: "Valitse huone jatkaaksesi. Listassa ovat vain tämän asunnon huoneet.",
            note: "Uusi elementti on aluksi kopio elementistä {{name}}, samalla materiaalilla ja hinnoilla.",
            detach_one: "Irrota {{count}} huone-elementti",
            detach_other: "Irrota {{count}} huone-elementtiä",
            detaching: "Irrotetaan…",
            errors: {
              Forbidden: "Sinulla ei ole oikeutta muuttaa elementtejä.",
              DifferentApartment: "Huone on eri asunnossa. Valitse toinen huone.",
              SeveralBundles: "Huone-elementit kuuluvat useampaan elementtiin. Irrota ne elementti kerrallaan.",
              Failed: "Huone-elementtien irrotus epäonnistui. Yritä uudelleen."
            }
          }
        },
        geometryDirectionalMove: {
          title: "Siirrä",
          prompt: "Osoita uusi sijainti ja klikkaa siirtääksesi"
        },
        extrudedLoopAreaSetExtrusionDepth: {
          title: "Aseta syvyys",
          prompt: "Muuta syvyyttä vetämällä ja aseta klikkaamalla"
        },
        geometryPlanarMove: {
          title: "Siirrä",
          prompt: "Osoita uusi sijainti ja klikkaa siirtääksesi"
        },
        geometryFreeMove: {
          title: "Siirrä",
          prompt: "Osoita uusi sijainti ja klikkaa siirtääksesi"
        },
        switchInputPlane: "Vaihda syöttötaso",
        switchInputPlaneTooltip: "Määritä mitta pintaa pitkin tai pintaa vastaan kohtisuoraan. Pikanäppäin: Hiiren oikea painike"
      },
      document: {
        userRights: {
          tooltip: "Käyttöoikeudet",
          create: "Luonti",
          read: "Luku",
          update: "Muokkaus",
          delete: "Poisto",
          scopeAll: "Kaikki",
          scopeGroup: "Ryhmä",
          scopeOwn: "Omat",
          scopeNoRights: "Ei oikeuksia",
        }
      },
      common: {
        ok: "OK",
        cancel: "Peruuta",
        save: "Tallenna",
        close: "Sulje",
        abort: "Keskeytä",
        yes: "Kyllä",
        no: "Ei",
      },
      debug: {
        viewerModeInspect: "Tarkastele",
      }
    }
};

export default fi;
